import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare var jQuery : any;

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {

  public selected:any;
  public projectList:any;
  public tabs:any;
  public data:any;
  public category:any = null;
  constructor(
    private activatedRoute: ActivatedRoute
  ) {
    this.selected = 'all';
    this.tabs = [];
    this.projectList = {
      'tab01': [
        {"location": "Tiara Hill, Cheras", "country": "Malaysia", "title": "Conceptual Design for Semi Detached House", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img15.png"
          ]
        }
      ],
      "tab02": [
        {"location": "sentul", "country": "Malaysia", "title": "Conceptual Design for Condo Lift Lobby, Cafe & Retail Show", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img1.jpg"
          ]
        }
      ],
      "tab03": [
        {"location": "Shopping Mall, Klang", "country": "Malaysia", "title": "Conceptual Design, Construct, Fit Out Works and Renovation for Bowling Center", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img2.png"
          ]
        },
        {"location": "Shopping Mall, Klang", "country": "Malaysia", "title": "Conceptual Design, Construct, Fit Out Works and Renovation for Indoor Drift Kart", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img3.png"
          ]
        },
        {"location": "Shopping Mall, Klang", "country": "Malaysia", "title": "Conceptual Design for F&B (CHINESE RESTAURANT & BANQUET HALL)", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img4.png"
          ]
        },
        {"location": "Shopping Mall, Klang", "country": "Malaysia", "title": "Conceptual Design, Construct, Fit Out Works and Renovation for Management Office", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img5.png"
          ]
        },
        {"location": "Shopping Mall, Klang", "country": "Malaysia", "title": "Conceptual Design, Construct, Fit Out Works and Renovation for Car Showroom", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img6.png"
          ]
        },
        {"location": "Shopping Mall, Klang", "country": "Malaysia", "title": "Conceptual Design for Retail (GROCERY)", "category": "concept_design",
          "images": [
            "/assets/images/project-new/residential/img7.png"
          ]
        },
        {"location": "Shopping Mall, Klang", "country": "Malaysia", "title": "Graphic Design, Construct, Fit Out Works and Renovation for Mall Public Area including lift lobby, toilet, car park, signages and directory",
          "images": [
            "/assets/images/project-new/residential/img8.jpg"
          ]
        }
      ],
      "tab04": [
        {"location": "mont kiara", "country": "Malaysia", "title": "Interior Design for Hilltop Pavilion",
          "images": [
            "/assets/images/project-new/residential/img9.png"
          ]
        }
      ],
      "tab05": [
        {"location": "kuala lumpur", "country": "Malaysia", "title": "Interior Design, Construct, Fit Out Works and Renovation for Banyan Tree Residences",
          "images": [
            "/assets/images/project-new/residential/img10.jpg"
          ]
        },
        {"location": "kuala lumpur", "country": "Malaysia", "title": "Interior Design, Construct, Fit Out Works and Renovation for The Troika Residences Penthouse",
          "images": [
            "/assets/images/project-new/residential/img11.png"
          ]
        },
        {"location": "kuala lumpur", "country": "Malaysia", "title": "Design & Built for Cosmo's World Indoor Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img1.jpg"
          ]
        },
        {"location": "kuala lumpur", "country": "Malaysia", "title": "Design & Built for Kidzania Learning and Entertainment Center",
          "images": [
            "/assets/images/project-new/hospitality/img7.jpg"
          ]
        }
      ],
      "tab06": [
        {"location": "selayang", "country": "Malaysia", "title": "Interior Design, Construct, Fit Out Works and Renovation for Wanda Car Showroom",
          "images": [
            "/assets/images/project/selayang/39-2.jpg"
          ]
        }
      ],
      // "tab07": [
      //   {"location": "petaling jaya", "country": "Malaysia", "title": "Jungle Gym",
      //     "images": [
      //       "/assets/images/project/petaling-jaya/87-1.jpg",
      //       "/assets/images/project/petaling-jaya/87-3.jpg",
      //       "/assets/images/project/petaling-jaya/88-1.jpg",
      //       "/assets/images/project/petaling-jaya/88-3.jpg"
      //     ]
      //   }
      // ],
      // "tab08": [
      //   {"location": "penang", "country": "Malaysia", "title": "Jurassic Research Centre",
      //     "images": [
      //       "/assets/images/project/penang/90.jpg",
      //       "/assets/images/project/penang/92-2.jpg",
      //       "/assets/images/project/penang/92-3.jpg",
      //       "/assets/images/project/penang/92-4.jpg",
      //       "/assets/images/project/penang/93-1.jpg",
      //       "/assets/images/project/penang/93-2.jpg",
      //       "/assets/images/project/penang/93-3.jpg",
      //       "/assets/images/project/penang/93-4.jpg"
      //     ]
      //   },
      //   {"location": "penang", "country": "Malaysia", "title": "Ocean Explorer",
      //     "images": [
      //       "/assets/images/project/penang/95.jpg",
      //       "/assets/images/project/penang/96-1.jpg",
      //       "/assets/images/project/penang/96-2.jpg",
      //       "/assets/images/project/penang/96-3.jpg",
      //       "/assets/images/project/penang/97-1.jpg",
      //       "/assets/images/project/penang/97-2.jpg",
      //       "/assets/images/project/penang/97-3.jpg",
      //       "/assets/images/project/penang/97-4.jpg"
      //     ]
      //   },
      //   {"location": "penang", "country": "Malaysia", "title": "Boutique Aquarium Komtar",
      //     "images": [
      //       "/assets/images/project/penang/100-2.jpg",
      //       "/assets/images/project/penang/100-1.jpg"
      //     ]
      //   }
      // ],
      "tab09": [
        {"location": "putrajaya", "country": "Malaysia", "title": "Design & Built for District 21 post-apocalyptic themed Sports and Recreation Park",
          "images": [
            "/assets/images/project-new/hospitality/img2.JPG"
          ]
        }
      ],
      "tab10": [
        {"location": "johor", "country": "Malaysia", "title": "Design & Built for Legoland Family Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img8.jpg"
          ]
        },
        {"location": "johor", "country": "Malaysia", "title": "Design & Built for Puteri Harbour Hello Kitty Indoor Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img11.jpg"
          ]
        }
      ],
      'tab11': [
        {"location": "melbourne", "country": "Australia", "title": "Interior Design, Construct, Fit Out Works and Renovation Swanston Central",
          "images": [
            "/assets/images/project-new/residential/img14.png"
          ]
        }
      ],
      'tab12': [
        {"location": "shanghai", "country": "China", "title": "Interior Design, Construct, Fit Out Works and Renovation for Tongji Design Park Office",
          "images": [
            "/assets/images/project-new/residential/img12.png"
          ]
        }
      ],
      'tab13': [
        {"location": "xiangyang", "country": "China", "title": "3D Scale Model, Design & Built for River Journey Theme at Fantasy Village Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img4.jpg"
          ]
        },
        {"location": "xiangyang", "country": "China", "title": "3D Scale Model, Design & Built for Show Mountain Theme at Fantasy Village Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img5.jpg"
          ]
        },
        {"location": "xiangyang", "country": "China", "title": "3D Scale Model, Design & Built for Water Park",
          "images": [
            "/assets/images/project-new/hospitality/img14.jpg"
          ]
        }
      ],
      'tab14': [
        {"location": "shenzhen", "country": "China", "title": "3D Scale Model, Design & Built for Aquarium at Jingsa Bay International Entertainment Park",
          "images": [
            "/assets/images/project-new/hospitality/img6.jpg"
          ]
        }
      ],
      'tab15': [
        {"location": "qingdao", "country": "China", "title": "Design & Built for Power Long Indoor Amusement Park",
          "images": [
            "/assets/images/project-new/hospitality/img10.jpg"
          ]
        }
      ],
      'tab16': [
        {"location": "gui an", "country": "China", "title": "Design & Built for Family Aquarium Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img3.jpg"
          ]
        }
      ],
      'tab17': [
        {"location": "singapore", "country": "Singapore", "title": "Design & Built for Marine Life Park, Adventure Cove water park",
          "images": [
            "/assets/images/project-new/hospitality/img9.jpg"
          ]
        },
        // {"location": "singapore", "country": "Singapore", "title": "Design & Built for Transformer Ride, External Facade, Signage & Bumble Bee",
        //   "images": [
        //     "/assets/images/project-new/hospitality/img13.jpg"
        //   ]
        // }
      ],
      'tab18': [
        {"location": "dubai", "country": "Dubai", "title": "Design & Built for Stargate Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img12.png"
          ]
        }
      ],
      'tab19': [
        {"location": "bahrain", "country": "Bahrain", "title": "Design & Built for Discovery Village Theme Park",
          "images": [
            "/assets/images/project-new/hospitality/img17.jpg"
          ]
        }
      ],
      'tab20': [
        {"location": "saudi arabia", "country": "Saudi Arabia", "title": "Design & Built for Fun Oasis",
          "images": [
            "/assets/images/project-new/hospitality/img16.jpg"
          ]
        }
      ],
      'tab21': [
        {"location": "oman", "country": "Oman", "title": "3D Concept Design for Happy Land Indoor Theme Park", "category": "3d_sculpture",
          "images": [
            "/assets/images/project-new/hospitality/img15.jpg"
          ]
        }
      ]
    }
    this.data = {};
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if(params.category){
        this.category = params.category;
        console.log(this.projectList)
        this.selected = 'category';
        for(let key in this.projectList){
          if (this.projectList.hasOwnProperty(key)) {
            for(let x = 0; x < this.projectList[key].length; x++){
              var pro = this.projectList[key][x];
              if(pro['category'] === this.category){
                this.tabs.push(pro)
              }
            }
          }
        }
        if(this.tabs.length == 0){
          this.selected = 'all'
        }
      }
    })
  }

  selectedTab(num:any){
    this.selected = num;
    if(num !== 'all'){
      this.tabs = this.projectList[num]
    }
  }

  viewData(info:object){
    // this.data = info;
    // console.log(this.data)
    // jQuery('#exampleModal').modal('show');
  }

  closeModal() {
    jQuery('#exampleModal').modal('hide');
  }
}
